import { useState } from 'react';
import Button from '../../components/Button/Button';
import Card from '../../components/Card/Card';
import { isDevEnv } from '../../utils/constants/common';
import PaymentFailure from './PaymentFailure';
import PaymentSuccess from './PaymentSuccess';
// import congrats from ;

const Congratulations = ({ checkPaymentStatus, setCheckPaymentStatus }) => {
  // const [checkPaymentStatus, setCheckPaymentStatus] = useState({
  //   flag: false,
  //   status: 0,
  // }); // init status to 0
  console.log('payment hit');

  if (checkPaymentStatus.status === 1 && checkPaymentStatus.flag === true) {
    return <PaymentSuccess />;
  } else if (
    checkPaymentStatus.status === 0 &&
    checkPaymentStatus.flag === false
  ) {
    return <PaymentFailure />;
  }
  return (
    <div className="w-full flex flex-col gap-11">
      <Card>
        <div className="grid grid-flow-col grid-rows-1 grid-cols-2 gap-10 px-14">
          <div className="flex items-center">
            <img
              src={
                require('../../assets/images/congrats_insurance.svg').default
              }
              alt=""
              className="max-h-[355px] h-[355px] object-contain min-w-[300px]"
            />
          </div>
          <div className="flex justify-center items-center">
            <div className="flex flex-col gap-6 justify-center items-center">
              <h1 className="text-left font-bold text-[35px] leading-[34px]">
                Congratulations
              </h1>
              <p className="text-left text-sm pt-4 font-normal">
                Your “Forward Payment Request” has been sent successfully. The
                policy will be booked when the customer does the payment.
              </p>
              <p className="text-blue-900 text-sm font-bold">
                Quotation Number: EIBLMTRPC2022082211443612
              </p>
              <div className="flex gap-4">
                <Button
                  size={'medium'}
                  onClick={() => {
                    setCheckPaymentStatus((p) => ({ flag: true, status: 1 }));
                  }}
                >
                  Check Payment Status
                </Button>
                {isDevEnv ? (
                  <Button
                    size={'medium'}
                    onClick={() => {
                      setCheckPaymentStatus((p) => ({
                        flag: false,
                        status: 0,
                      }));
                    }}
                  >
                    Check Payment Status(f)
                  </Button>
                ) : null}
                <Button size={'medium'} variant={'text'}>
                  Proceed to Home
                </Button>
              </div>
            </div>
          </div>
        </div>
      </Card>

      {/* <DevTool control={control} /> */}
    </div>
  );
};

export default Congratulations;
